module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"array-control-list-item\">\n	<div>")
    ; __append(escapeFn( item ))
    ; __append("</div>\n	<div style=\"width: 30px; text-align: center\"><div name=\"remove-button\" class=\"icon-trash-o\" data-index=\"")
    ; __append(escapeFn( index ))
    ; __append("\" data-item=\"")
    ; __append(escapeFn( item ))
    ; __append("\"></div></div>\n</div>\n")
  }
  return __output.join("");

}